import { getBotData } from './get-bot-data'
import type { Player } from '@acepoker/contract/acepoker'

export function getAvatarId(player: Player): number {
  if (player.avatarId) return Number(player.avatarId)

  if (player.bot) {
    const botData = getBotData(player)
    return Number(botData?.avatarId || 0)
  }

  return 0
}
